import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoordinatesMobile = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 6,
			r: 5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 14.2061C19.0571 14.7795 22 16.4851 22 18.5C22 20.9853 17.5228 23 12 23C6.47715 23 2 20.9853 2 18.5C2 16.4851 4.9429 14.7795 9 14.2061V16.2285C7.72598 16.4297 6.61828 16.7509 5.75 17.1416C4.99947 17.4793 4.51413 17.8299 4.24316 18.1182C4.11273 18.2569 4.05085 18.3606 4.02344 18.4209C3.99861 18.4755 4 18.4979 4 18.5C4 18.5021 3.99861 18.5245 4.02344 18.5791C4.05085 18.6394 4.11273 18.7431 4.24316 18.8818C4.51413 19.1701 4.99947 19.5207 5.75 19.8584C7.24671 20.5318 9.45463 21 12 21C14.5454 21 16.7533 20.5318 18.25 19.8584C19.0005 19.5207 19.4859 19.1701 19.7568 18.8818C19.8873 18.7431 19.9492 18.6394 19.9766 18.5791C20.0014 18.5245 20 18.5021 20 18.5C20 18.4979 20.0014 18.4755 19.9766 18.4209C19.9492 18.3606 19.8873 18.2569 19.7568 18.1182C19.4859 17.8299 19.0005 17.4793 18.25 17.1416C17.3817 16.7509 16.274 16.4297 15 16.2285V14.2061ZM12 14C12.3375 14 12.6711 14.0078 13 14.0225V16.0244C12.6733 16.0084 12.3396 16 12 16C11.6604 16 11.3267 16.0084 11 16.0244V14.0225C11.3289 14.0078 11.6625 14 12 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 8,
			width: 2,
			height: 11,
			fill: "currentColor"
		})
	]
});
export default SvgCoordinatesMobile;
